/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const createAdminModelSchema = z.object({
    "login": z.string().min(4).max(25).describe("Логин"),
"password": z.string().min(4).max(25).describe("Пароль")
    })